<item-photo [attachmentId]="photo()?.attachmentId" [label]="label()" [size]="size()"></item-photo>
@if (multi()) {
  <span class="order-face-count text-mono">{{ photos().length }}</span>
}
